"use client";
import { cn as e } from "../../../utils/utils.mjs";
import { Input as t } from "../../atoms/Input/Input.mjs";
import { IconButton as n } from "../../atoms/IconButton/IconButton.mjs";
import { MediaSelect as r } from "../../molecules/MediaSelect/MediaSelect.mjs";
import { MediaSelectContent as i } from "../../molecules/MediaSelect/MediaSelectContent.mjs";
import { MediaSelectItem as a } from "../../molecules/MediaSelect/MediaSelectItem.mjs";
import { useState as o } from "react";
import { jsx as s, jsxs as c } from "react/jsx-runtime";
import { Close as l, Search as u } from "@videoblocks/react-icons";
//#region src/components/organisms/ProminentSearch/ProminentSearch.tsx
var d = ({ value: d, defaultValue: f, onChange: p, placeholder: m, autoFocus: h, "aria-label": g = "Search", onSubmit: _, onClose: v, showClose: y = !1, selectOptions: b, selectValue: x, defaultSelectValue: S, onSelectChange: C, submitAriaLabel: w = "Submit search", className: T, mediaSelectProps: E, ...D }) => {
	let [O, k] = o(f ?? ""), A = d !== void 0, j = A ? d : O, [M, N] = o(S), P = x !== void 0, F = P ? x : M, I = !!b && b.length > 0, L = b?.find(({ value: e }) => e === F)?.placeholder ?? m, R = (e) => {
		A || k(e.target.value), p?.(e);
	};
	return /* @__PURE__ */ c("form", {
		role: "search",
		onSubmit: (e) => {
			e.preventDefault(), _?.({
				value: j,
				selectValue: F
			});
		},
		className: e("flex h-11 w-full items-center gap-3 rounded-[999px] bg-neutral-dark-200 px-1", T),
		children: [
			I && /* @__PURE__ */ s(r, {
				value: P ? x : void 0,
				defaultValue: P ? void 0 : S,
				onValueChange: (e) => {
					P || N(e), C?.(e);
				},
				placeholder: b[0]?.label ?? "Select",
				className: "h-9 min-w-[90px] gap-2 bg-neutral-dark-100 px-3 py-2 text-sm text-white hover:border-transparent hover:bg-neutral-dark-200",
				...E,
				children: /* @__PURE__ */ s(i, { children: b.map((e) => /* @__PURE__ */ s(a, {
					value: e.value,
					icon: e.icon,
					selectItemLabel: e.selectItemLabel,
					children: e.label
				}, e.value)) })
			}),
			/* @__PURE__ */ s(t, {
				type: "search",
				tone: "dark",
				value: j,
				onChange: R,
				placeholder: L,
				autoFocus: h,
				"aria-label": g,
				className: "h-10 flex-1 rounded-[999px] border-0 bg-neutral-dark-200 px-2 text-base font-normal text-neutral-dark-1000 placeholder:text-neutral-dark-700 focus:ring-0 focus:outline-none [&::-webkit-search-cancel-button]:hidden",
				...D
			}),
			y ? /* @__PURE__ */ s(n, {
				type: "button",
				variant: "secondary",
				size: "small",
				"aria-label": "Close search",
				onClick: v,
				icon: /* @__PURE__ */ s(l, { className: "fill-white" }),
				className: "bg-neutral-dark-100 hover:bg-neutral-dark-400"
			}, "close") : /* @__PURE__ */ s(n, {
				type: "submit",
				variant: "secondary",
				size: "small",
				"aria-label": w,
				icon: /* @__PURE__ */ s(u, { className: "fill-white" }),
				className: "bg-neutral-dark-100 hover:bg-neutral-dark-400"
			}, "submit")
		]
	});
};
//#endregion
export { d as ProminentSearch };
